import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReleaseFlagForm } from "../ReleaseFlagForm";
import useCreateReleaseFlag from "./api/useCreateReleaseFlag";
import { ReleaseFlagFormValues } from "../types";
import { handleAlert } from "@utils/helperFunctions";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";

const emptyValues: ReleaseFlagFormValues = {
  name: "",
  key: "",
  description: "",
  status: "building",
  betaReleaseDate: "",
  generalAvailabilityDate: "",
};

const New: React.FC = () => {
  const navigate = useNavigate();
  const { submit, isLoading } = useCreateReleaseFlag();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleSubmit = (values: ReleaseFlagFormValues) => {
    submit(values)
      .then(() => {
        setResponseMessage("Release flag created");
        setShowSuccess(true);
        setTimeout(() => navigate("/admin/release_flags"), 500);
      })
      .catch((err: any) => {
        const detail =
          err?.data?.errors?.[0]?.detail || "Could not create release flag.";
        setResponseMessage(detail);
        setShowFail(true);
      });
  };

  return (
    <div className="releaseFlagsPage">
      <ReleaseFlagForm
        mode="new"
        title="New Release Flag"
        initialValues={emptyValues}
        onSubmit={handleSubmit}
        onCancel={() => navigate("/admin/release_flags")}
        isSubmitting={isLoading}
      />
      {handleAlert(
        showSuccess,
        responseMessage,
        setShowSuccess,
        "success",
        ToastAlert
      )}
      {handleAlert(
        showFail,
        responseMessage,
        setShowFail,
        "warning",
        ToastAlert
      )}
    </div>
  );
};

export default New;
